export default __webpack_public_path__ + "static/media/ic_close.fe553d79.svg";